// src/services/reporting.js - DycoVue reading workflow (radiologist claim/report cycle)
import api from './api';

export const requestDycovueReport = async (studyId, requestData) => {
  try {
    const response = await api.post(`/studies/${studyId}/request-dycovue`, requestData);
    return response.data;
  } catch (error) {
    console.error('Request Dycovue report error:', error);
    throw error;
  }
};

export const cancelDycovueRequest = async (studyId) => {
  try {
    const response = await api.post(`/studies/${studyId}/cancel-dycovue-request`);
    return response.data;
  } catch (error) {
    console.error('Cancel Dycovue request error:', error);
    throw error;
  }
};

export const getAvailableForClaiming = async (filters = {}) => {
  try {
    const response = await api.get('/studies/dycovue/available', { params: filters });
    return response.data;
  } catch (error) {
    console.error('Get available studies error:', error);
    throw error;
  }
};

export const claimStudy = async (studyId) => {
  try {
    const response = await api.post(`/studies/${studyId}/claim`);
    return response.data;
  } catch (error) {
    console.error('Claim study error:', error);
    throw error;
  }
};

export const unclaimStudy = async (studyId) => {
  try {
    const response = await api.post(`/studies/${studyId}/unclaim`);
    return response.data;
  } catch (error) {
    console.error('Unclaim study error:', error);
    throw error;
  }
};

export const getMyAssignedStudies = async (params = {}) => {
  try {
    const response = await api.get('/studies/dycovue/my-assigned', { params });
    return response.data;
  } catch (error) {
    console.error('Get assigned studies error:', error);
    throw error;
  }
};

export const getAllStudiesForRadiologist = async (params = {}) => {
  try {
    const response = await api.get('/studies', { params: { ...params, viewMode: 'all' } });
    return response.data;
  } catch (error) {
    console.error('Get all studies (radiologist) error:', error);
    throw error;
  }
};

export const getMyRadiologistStats = async () => {
  try {
    const response = await api.get('/studies/radiologist/stats');
    return response.data;
  } catch (error) {
    console.error('Get radiologist stats error:', error);
    throw error;
  }
};

export const getAssignedHospitals = async (params = {}) => {
  try {
    const response = await api.get('/studies/radiologist/assigned-hospitals', { params });
    return response.data;
  } catch (error) {
    console.error('Get assigned hospitals error:', error);
    throw error;
  }
};

export const getAssignedHospitalStudies = async (params = {}) => {
  try {
    const response = await api.get('/studies/radiologist/assigned-hospital-studies', { params });
    return response.data;
  } catch (error) {
    console.error('Get assigned hospital studies error:', error);
    throw error;
  }
};
